<template>
  <section
    v-loading="loading"
    element-loading-text="等待最終支付完成"
    element-loading-spinner="el-icon-loading"
    class="detail-page-container">
    <div class="top-bar">
      <span>MicroPolicy</span>
    </div>
    <section class="main-container">
      <div
        class="main-header flex-sb"
        :class="{'has-border':showAdjustPolicy}">
        <div>
          <div class="header-title">
            <span
              class="icon"
              :class="{
                'gray': detailData.effectiveness == 1,
                'green': detailData.effectiveness == 2,
                'red': detailData.effectiveness == 3
              }">
              <font-awesome-icon
                icon="file-powerpoint"
              />
            </span>
            <h3>{{ detailData.company_language }}&nbsp;{{detailData.plan}}</h3>
            <span
              v-if="detailData.according_pcy_no"
              class="hcid">Policy No.  <span class="number-color">{{ detailData.according_pcy_no }}</span></span>
            <span
              v-if="detailData.order_sn"
              class="hcid">Ref <span class="number-color">{{ detailData.order_sn }}</span></span>
            <span
              v-if="detailData.pcy_no"
              class="hcid">Policy <span class="number-color">{{ detailData.pcy_no }}</span></span>
            <span
              v-if="detailData.cert_no"
              class="hcid">Certificate <span class="number-color">{{ detailData.cert_no }}</span></span>
          </div>
          <div>
            <span
              class="span-status"
              :class="{
                'orange': [401, 301].includes(detailData.pcy_stts),
                'yellow-dark': detailData.pcy_stts == 410,
                'blue': [420, 505, 705].includes(detailData.pcy_stts),
                'green': [425, 501, 510, 701].includes(detailData.pcy_stts),
                'red': [801, 0,4096].includes(detailData.pcy_stts),
                'purple': [710].includes(detailData.pcy_stts),
              }">
              <font-awesome-icon
                v-if="[425, 510].includes(detailData.pcy_stts)"
                icon="clipboard-check" />
              <font-awesome-icon
                v-if="detailData.pcy_stts == 401"
                icon="pen-nib" />
              <font-awesome-icon
                v-if="detailData.pcy_stts == 410"
                icon="check" />
              <font-awesome-icon
                v-if="[420, 505, 705].includes(detailData.pcy_stts)"
                icon="print" />
              <font-awesome-icon
                v-if="detailData.pcy_stts == 801"
                icon="hourglass-end" />
              <font-awesome-icon
                v-if="[301, 501, 701].includes(detailData.pcy_stts)"
                icon="file-invoice-dollar" />
              <font-awesome-icon
                v-if="detailData.pcy_stts == 0"
                icon="skull" />
              <font-awesome-icon
                v-if="[710].includes(detailData.pcy_stts)"
                icon="calendar-check" />
              {{ detailData.pcy_stts_language }}
            </span>
            <span
              v-for="(v,i) in detailData.tag_language"
              :key="i"
              class="span-options"
              :class="{
                'gold': v.id == 1,
                'blue': [2,16,64].includes(v.id),
                'orange': v.id == 4,
                'red': v.id == 4096,
                'black': [8,32,128].includes(v.id)
              }"
            >{{v.name}}</span>
            <span class="header-date">Created  <span class="number-color number-fontsize">{{ detailData.sort_time }}</span></span>
            <span class="header-date">Last Updated  <span class="number-color number-fontsize">{{ detailData.updated_at }}</span></span>
          </div>
        </div>
        <div class="form-item">
          <span>Assignee</span>
          <span>

            <v-select
              v-model="detailData.cs_id"
              icon="user-nurse"
              :list="assigneeList"
              :clearable="true"
              @change="selectAssignee"
            />
          </span>
        </div>
      </div>
      <div
        v-if="showMain"
        class="main-body">
        <section class="main-content">
          <section class="status-bar-container">
            <div
              v-if="showEndorsementStatusBar && false"
              class="status-bar status-bar-endorsement flex-sb">
              <div class="left">
                <span>Endrosement Quote</span>
                <span>This policy has an endorsement quote pending.</span>
              </div>
              <div class="right">
                <v-button @click="viewTicket">View Support Ticket</v-button>
              </div>
            </div>
            <div
              v-if="currentFormData.pcy_stts == 0"
              class="void-status">
              <span>Void</span>
              <span>This policy has been voided.</span>
            </div>
          </section>

          <el-tabs
            v-model="activeTab"
            @tab-click="handleChangeLog">
            <el-tab-pane
              v-for="(tab, index) in tabList"
              :key="index"
              :label="tab.label"
              :name="String(tab.name)"
            ></el-tab-pane>
          </el-tabs>
          <div
            v-if="refund"
            class="mg-b-15">
            <v-warning
              :text="'This policy is overdue for void and refund.'"
              :icon="'hand-holding-dollar'"
              @click="handleVoidQuote"
            ></v-warning>
          </div>

          <detail-tab
            v-show="activeTab == 'Detail'"
            :activeTab="activeTab"
            :form="detailData"
            @getCurrentOrderId="getCurrentOrderId"
            @changeCurrentFormData="getCurrentFormData"
            @adjust="handlerAdjustPolicy"
            @tabName="handTabName"
            @update="handler().updatePolicyDetail(0)"
          />

          <policy-docs
            v-show="activeTab == 'Policy Docs'"
            :form="detailData"
            :invoice="currentFormData.policy_invoice"
            @update="handler().updatePolicyDetail(0)"
          />
          <payment-record
            v-show="activeTab == 'Payment Record'"
            :records="detailData.payment_record">
          </payment-record>
          <tickets-tab
            v-show="activeTab == 'Tickets'"
            :form="detailData"
            @update-data="updateTicketsData"
          />

          <claims-tab
            v-show="activeTab == 'Claims'"
            :claims="detailData.claims_record" />

          <the-cheques
            v-show="activeTab == 'Cheques'"
            :cheques="detailData.cheques"
            @update="handler().updatePolicyDetail(0)" />

          <detail-log
            v-show="activeTab == 'log'"
            :logsData="logsData">
          </detail-log>
        </section>

        <aside>
          <div
            v-if="isMobile&&(missingImei||markIssuing||markIssued)"
            class="btn-list border-b unbuyable-status"
          >
            <span
              v-if="missingImei"
              class="title">Missing IMEI</span>
            <span
              v-if="markIssuing"
              class="title">Waiting to be issuing</span>
            <span
              v-if="markIssued"
              class="title">Waiting to be issued</span>
            <div
              v-if="missingImei"
              class="button-width">
              <v-button
                green
                icon="pen"
                class="button-weight green"
                @click="handlerAdjustPolicy"
              >
                <span>Update IMEI</span>
              </v-button>
            </div>
            <div
              v-if="markIssuing"
              class="button-width">
              <v-button
                green
                icon="clipboard-check"
                class="button-weight green"
                @click="handlerMarkIssuing"
              >
                <span>Mark As Issuing</span>
              </v-button>
            </div>
            <div
              v-if="markIssued"
              class="button-width">
              <v-button
                green
                icon="clipboard-check"
                class="button-weight green"
                @click="handlerMarkIssued"
              >
                <span>Mark As Issued</span>
              </v-button>
            </div>
          </div>
          <div class="card child-button-block">
            <span class="label">Support</span>
            <div
              v-if="isEndorse"
              class="button-width">
              <v-button
                icon="pen"
                class="button-weight"
                @click="handlerEndorsePolicy"
              >Mark As Endorsed
              </v-button>
            </div>
            <div class="button-width">
              <v-button
                icon="plus"
                class="button-weight"
                @click="openDialog('new-general-ticket')"
              >New General Ticket
              </v-button>
            </div>
            <div
              v-show="showClaimTicketBtn"
              class="button-width">
              <v-button
                icon="plus"
                class="button-weight"
                @click="openDialog('new-claim-ticket')"
              >New Claim Ticket
              </v-button>
            </div>
            <div
              v-if="showVoidBtn"
              class="button-width">
              <v-button
                icon="skull"
                class="button-weight"
                @click="handlerVoidPolicy"
              >Void Policy
              </v-button>
            </div>
          </div>
          <div
            v-if="detailData.customer"
            class="card">
            <span class="label">Customer Profile</span>
            <router-link
              :to="{path:'/accounts/detail',query:{customer_id:detailData.customer_id}}"
              class="flex flex-wrap text-decoration-none">
              <span
                v-if="isShowName"
                class="name hand"
                @click="viewCustomer">{{ detailData.customer.isrd_nm }} &nbsp;</span>
              <span
                v-else
                class="name hand unname"
                @click="viewCustomer">Unnamed Account &nbsp;</span>
              <span
                v-if="detailData.id_type!=3&& detailData.customer.nick_name"
                class="name small hand"
                @click="viewCustomer">({{ detailData.customer.nick_name }})</span>
            </router-link>

            <div class="table">
              <div class="tr">
                <span>Joined</span>
                <span>{{ detailData.customer.created_at }}</span>
              </div>
              <div class="tr">
                <span>Policies</span>
                <span>{{ detailData.customer.polices }} Active</span>
              </div>
            </div>
            <div class="flex-sb">
              <span class="label">Description</span>
              <span
                class="edit blue"
                @click="editDescription">Edit</span>
            </div>
            <div
              class="description-content"
              v-html="customer_description">
            </div>
            <router-link
              :to="{path:'/accounts/detail',query:{customer_id:detailData.customer_id}}">
              <v-button
                type="primary"
                @click="viewCustomer">View Customer</v-button>
            </router-link>
          </div>

          <div class="card plan-card">
            <span class="label">Plan Info</span>
            <div class="flex">
              <div class="logo">
                <img
                  :src="detailData.company_logo"
                  alt="company"
                />
              </div>
              <p>{{ detailData.plan }}</p>
            </div>
          </div>

          <div class="card">
            <span class="title">Internal Remarks</span>
            <div class="remarks-container">
              <div
                v-for="(item, index) in remarkList"
                :key="index"
                class="remark-box">
                <div class="remark-header">
                  <span>{{ item.cs_name }}</span>
                  <span>{{ item.created_at }}</span>
                </div>
                <p>{{ item.message }}</p>
              </div>
            </div>
            <div class="remark-add">
              <v-input
                v-model="message"
                class="mg-b-15"
                @keyEnter="handlerAddRemark" />
              <v-button
                size="small"
                type="primary"
                @click="handlerAddRemark">Add Remark</v-button>
            </div>
          </div>
        </aside>
      </div>
      <div
        v-else
        class="other-body">
        <section v-show="showAdjustPolicy">
          <adjust-policy
            :form="detailData"
            :customer="customer_profile"
            :isAdjust="is_adjust"
            @cancel="handlerAdjustCancel"
            @success="handlerAdjustDone"
            @handlerRefresh="handlerRefresh"
          />

        </section>
      </div>
    </section>


    <!-- dialog -->
    <new-general-ticket
      ref="new-general-ticket"
      :customer="ticketCustomer"
      :form="ticketParams" />
    <new-endorsement-ticket
      ref="new-endorsement-ticket"
      :orderId="currentOrderId"
      :customer="ticketCustomer"
      :form="ticketParams" />
    <new-claim-ticket
      ref="new-claim-ticket"
      :orderId="orderId"
      :form="ticketParams"
      :customer="ticketCustomer"
    />
    <create-cheque
      ref="create-cheque"
      :form="chequeParams"
      @done="handler().updatePolicyDetail(0)" />

    <plan-dialog
      ref="plan-dialog"
      :planInfo="currentFormData.quote_coverage_list" />

    <send-email-sms
      ref="send-email-sms"
      :initContent="void_sms_content"
      :form="sendSMSForm"
      :type = "3"
      @send="handlerSend"
      @skip="handlerSkip"
      @close="handlerClose" />
    <set-void-quote
      ref="void-quote-dialog"
      :orderId="orderId"
      :is-normal="false"
      :buy-data="detailData.buy_data"
      :type="4"
      @setVoid="handlerVoidDone"
    ></set-void-quote>
    <mark-as-issued
      ref="mark-as-issued"
      :form="detailData"
      :orderId="orderId"
      @success="handler().updatePolicyDetail(0)"
    />
    <send-email-sms
      ref="send-email-sms-issuing"
      :initContent="detailData.make_issuing_sms_content"
      :form="sendSMSForm"
      @send="handlerIssuingSend"
      @skip="handlerIssuingSkip"
      @close="handlerClose" />
    <edit-description
      ref="edit-description"
      :detailData="customer_profile"
      :customerId="detailData.customer_id"
      @update="getUpdateAccountData"></edit-description>

  </section>
</template>
<script>
import {mapActions} from 'vuex'
import MixinOptions from '@/mixins/options'
import DetailTab from './components/detail-tab'
import TicketsTab from './components/tickets-tab'
import MarkAsIssued from './components/dialog/mark-as-issued'
import TheCheques from './components/cheques'
import ClaimsTab from './components/claims-tab'
import PolicyDocs from './components/policy-docs'
import PaymentRecord from '@/views/records/policy/components/payment-record'
import NewGeneralTicket from '@/views/tickets/dialogs/new-general-ticket'
import NewEndorsementTicket from '@/views/tickets/dialogs/new-endorsement-ticket'
import NewClaimTicket from '@/views/tickets/dialogs/new-claim-ticket'
import SendEmailSms from '@/views/components/dialogs/send-email-sms'
import {addPolicyRemark, getPolicyDetailLog} from '@/api/policy'
import {
  covidVoidPolicy,
  getEwalletDetail,
  getInfectiousDetail,
  getMicropolicyDetail,
  getMobileDetail,
  getSportDetail,
  getOverseaPaDetail
} from '@/api/micropolicy'
import {
  completeNewBusinessOrder,
  issueOrderCvr,
  orderIssueIssuing,
  orderTurnToNewPcy,
  voidPolicyOrder
} from '@/api/order'
import {orderCsSet} from '@/api/quote'
import AdjustPolicy from './components/mobile-endorsement'
import CreateCheque from './components/dialog/create-cheque'
import PlanDialog from '@/views/quoting/dialogs/plan-dialog'
import {getAccountDetail} from '@/api/account'
import detailLog from '@/views/components/log/detail-log'
import SetVoidQuote from '@/views/components/set-void-quote'
import EditDescription from '@/views/accounts/dialog/edit-description'

export default {
  name: 'PolicyDetail',
  components: {
    DetailTab,
    PolicyDocs,
    TicketsTab,
    TheCheques,
    ClaimsTab,
    NewGeneralTicket,
    NewEndorsementTicket,
    NewClaimTicket,
    AdjustPolicy,
    CreateCheque,
    PlanDialog,
    SendEmailSms,
    detailLog,
    SetVoidQuote,
    PaymentRecord,
    MarkAsIssued,
    EditDescription
  },
  mixins: [MixinOptions],
  data() {
    return {
      activeTab: 'Detail',
      detailData: {
        customer: {}
      },
      formData: {}, // 當前選中 policy 數據
      // assignee: '',
      remarkList: [],
      message: '',
      showMain: true,
      showAdjustPolicy: false,
      currentOrderId: 0,
      currentFormData: {},
      pcyTimer: null,
      clearTime: 0,
      loading: false,
      is_adjust: false,
      errorCode: '',
      copyDetailData: null,
      orignal_cs:'',
      customer_profile:{},
      tabName:[],
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
      logsData:[],
      policyTabForm:{},
      voidData:{
        order_id: '',
        is_send: 0,
        content: ''
      },
      issuingForm:{
        is_send: 0,
        content: ''
      },
      mobileVoidParams:{}
    }
  },
  computed: {
    customer_description(){
      let str = this.customer_profile.description
      if(str){
        str = str.replaceAll('\n', '<br />')
      }
      return str
    },
    void_sms_content(){
      let {void_sms_content,void_sms_data} = this.detailData||{}
      if(void_sms_content&&this.productId==93){
        return void_sms_content
      }
      return void_sms_data
    },
    hasVoidSmsContent(){
      let {void_sms_content,void_sms_data} = this.detailData||{}
      return !!void_sms_content
    },
    productId() {
      return this.$route.query.product_id || 90
    },
    ticketCustomer(){
      return this.detailData.customer_id !== 0 ? this.detailData.customer : {}
    },
    sendSMSForm(){
      return {
        isrd_lst_nm:this.detailData.isrd_lst_nm,
        isrd_fst_nm:this.detailData.isrd_fst_nm,
        mobile_no:this.detailData.mobile_no,
        identity:this.detailData.customer.identity
      }
    },
    orderId() {
      return this.$route.query.id
    },
    pcyId() {
      return this.detailData.pcy_id
    },
    // 區分保單狀態，是否為 adjustable
    isAdjust() {
      // return true
      return this.currentFormData.type === 50
    },
    showComplete() {
      const { type, stts } = this.currentFormData
      if(stts >= 420) {
        return false
      }
      return [10, 20, 50].includes(type)
    },
    showClaimTicketBtn() {
      const { type, pcy_stts, customer_id} = this.detailData
      return [10, 20, 30, 40, 50].includes(type) && pcy_stts >= 420 && customer_id !== 0
    },
    showVoidBtn() {
      const { pcy_stts } = this.detailData
      // return [10, 20, 50].includes(type) && stts == 410
      if(this.productId==94)
        return pcy_stts==420
      return  pcy_stts >= 401 && pcy_stts < 420
      return pcy_stts !== 0&&pcy_stts<420
    },
    showChequeBtn() {
      return this.detailData.pcy_stts != 0
    },
    hasVoid(){
      const { pcy_stts } = this.detailData||{}
      return pcy_stts<420
    },
    showEndorsementStatusBar() {
      const { endorsement_quote_pending } = this.detailData
      if (!endorsement_quote_pending || !endorsement_quote_pending.id) {
        return false
      }
      return true
    },
    ticketParams() {
      const { cs_id, customer_id, pcy_no, quotation_number, pcy_id, mobile_no, phone_no } = this.detailData
      return {
        assignee_id: cs_id,
        customer_id,
        // policy_no: pcy_no,
        quote_no: quotation_number,
        pcy_id,
        contact_no: mobile_no? mobile_no: phone_no
      }
    },
    isHaveCancelRecord() {
      // 檢查 record 是否存在已完成的 cancel 單
      const { record = [] } = this.currentFormData
      if(!record || record.length < 1) {
        return false
      }
      let haveCancel = false
      record.some(item => {
        const { period_record = [] } = item
        period_record.some(inItem => {
          const { type, stts } = inItem
          if(type == 40 && stts >= 420) {
            haveCancel = true
            return true
          }
        })
        if(haveCancel) {
          return true
        }
      })
      return haveCancel
    },
    chequeParams() {
      const { customer, id, customer_id } = this.currentFormData
      return {
        isrd_nm: customer? customer.isrd_nm : '',
        order_id: id,
        customer_id
      }
    },
    pcyStts() {
      // const { stts } = this.detailData
      // return stts
      const { pcy_stts } = this.detailData
      return pcy_stts
    },
    newestOrderId() {
      const record = this.detailData.record || []
      if(record.length < 1) return false
      const { period_record = [] } = record[0]
      if(period_record && period_record.length > 0) {
        const len = period_record.length
        return period_record[len - 1].order_id
      }
      return record[0].order_id
    },
    isShowName(){
      let {customer,id_type} = this.detailData
      if(customer.isrd_nm)
        return customer.isrd_nm.trim()!=''
      else return  false
    },
    plan_info(){
      let {quote_coverage_list} = this.currentFormData||{}
      let {plan_info} =quote_coverage_list||{}
      return plan_info||{}
    },
    refund(){
      let {tag_language=[]} = this.detailData||{}
      let data = tag_language.filter(item=>item.id==4096)||{}
      return data.length>0
    },
    tabList(){
      let arr =  [
        {
          name: 'Detail',
          label: 'Detail'
        },
        {
          name: 'Policy Docs',
          label: 'Policy Docs'
        },
        {
          name: 'Tickets',
          label: 'Tickets'
        },
        {
          name: 'Claims',
          label: 'Claims'
        },
        {
          name: 'Cheques',
          label: 'Cheques'
        },
        {
          name: 'log',
          label: 'Log'
        }
      ]
      if(this.productId==93){
        arr.splice(        2,0,{
          name: 'Payment Record',
          label: 'Payment Record'
        },)
      }
      return arr
    },
    isMobile(){
      return this.productId == 93
    },
    missingImei(){
      let {update_imei_button} = this.detailData
      return update_imei_button == 1
    },
    isEndorse(){
      let {endorse_button} = this.detailData
      return endorse_button == 1
    },
    markIssuing(){
      return this.pcyStts == 410
    },
    markIssued(){
      return this.pcyStts == 420
    },
  },
  watch: {
    orderId: {
      handler(val, old) {
        if(old) {
          this.handler().initUpdatePolicyDetail()
        }
      }
    },
    pcyStts: {
      handler(val) {
        if(val == -1) {
          this.loading = true
          this.pcyTimer = setInterval(() => {
            // 如果 pcy stts 為 -1 則重新獲取數據
            this.handler().getProductData({
              hideLoading: true
            }, true)

            if((Date.now()/1000) - this.clearTime >= 10) {
              this.loading = false
              clearInterval(this.pcyTimer)
            }
          }, 1000)
        }
        else {
          this.loading = false
          clearInterval(this.pcyTimer)
        }
      }
    },
    'currentFormData.customer_id':{
      immediate:true,
      handler(val){
        if(val){
          this.network().getAccountDetail({customer_id:val})
        }
      }
    }
  },
  created() {
    // this.handler().getProductData({
    //   hideLoading: true
    // }, true)
    this.clearTime = Date.now()/1000

    const { tab = '' } = this.$route.query
    if (tab) {
      this.activeTab = this.$route.query.tab
    }
    this.setProductId(this.productId)
    this.network().getPolicyDetailLog()
    this.getProductDetail()
  },
  destroyed() {
    clearInterval(this.pcyTimer)
  },
  methods: {
    ...mapActions('common', ['setProductId']),
    ...mapActions('quote', ['setAllQuote', 'setQuoteForm', 'setQuoteResult']),
    ...mapActions('account', ['setCustomerId']),
    getUpdateAccountData() {
      this.network().getAccountDetail({customer_id:this.detailData.customer_id})
    },
    editDescription(){
      this.$refs['edit-description'].changeDialog()
    },
    handlerSend(content) {
      this.voidData.is_send = 1
      this.voidData.content = content
      this.voidData.order_id = this.orderId
      if(this.productId==93){
        this.network().voidPolicyOrder({
          is_send:1,
          void_sms_content:content})
        return
      }
      this.network().covidVoidPolicy({
        ...this.voidData,
      })
      this.handlerClose()
      this.getProductDetail()
    },
    handlerSkip() {
      this.voidData.is_send = 0
      this.voidData.content = ''
      this.voidData.order_id = this.orderId
      if(this.productId==93){
        this.network().voidPolicyOrder({
          is_send:0,
          void_sms_content:''})
        return
      }
      this.network().covidVoidPolicy({
        ...this.voidData,
      })
      this.handlerClose()
      this.getProductDetail()
    },
    handlerIssuingSkip() {
      this.issuingForm.is_send = 0
      this.issuingForm.content = ''
      this.network().orderIssueIssuing()
    },
    handlerIssuingSend(data) {
      this.issuingForm.is_send = 1
      this.issuingForm.content = data
      this.network().orderIssueIssuing()
    },
    handlerClose() {
      this.$refs['send-email-sms'].onCancel()
      this.$refs['send-email-sms-issuing'].onCancel()
    },
    handleChangeLog(){
      if(this.activeTab=='log')
        this.network().getPolicyDetailLog()
    },
    handTabName(data){
      this.tabName = data
    },
    selectAssignee(id) {
      id = id?id:0
      orderCsSet({
        order_id: this.orderId,
        cs_id: id,
      }).then(data=>{
        this.orignal_cs = id
        this.$message({
          type: 'success',
          message: 'Success'
        })
      }).catch(err=>{
        this.detailData.cs_id = this.orignal_cs
      })
      // this.network().setTicketCs({
      //   cs_id: id
      // })
    },
    handlerRefresh(){
      this.showMain = true
      this.showAdjustPolicy = false
      this.handler().initUpdatePolicyDetail()
    },
    viewCustomer() {
      this.$router.push({
        path: '/accounts/detail',
        query: {
          customer_id: this.detailData.customer_id
        }
      })
    },
    viewPlan() {
      this.$refs['plan-dialog'].changeDialog()
    },
    viewTicket() {
      const { endorsement_quote_pending } = this.currentFormData||{}
      const { id } = endorsement_quote_pending||{}
      this.$router.push({
        path: '/tickets/detail',
        query: {
          ticket_id: id
        }
      })
    },
    onViewEndorsementTicket() {
      const { ticket_id } = this.currentFormData
      this.$router.push({
        path: '/tickets/detail',
        query: {
          ticket_id
        }
      })
    },
    getCurrentOrderId(id) {
      this.currentOrderId = id
    },
    getCurrentFormData(data) {
      this.currentFormData = data
    },
    updateTicketsData(data) {
      this.getProductDetail()
    },
    handlerAddRemark() {
      if (this.message) {
        this.network().addPolicyRemark()
      }
    },
    openDialog(target) {
      if (target) {
        this.$refs[target].changeDialog()
      }
    },
    handlerVoid(){
      this.handler().initUpdatePolicyDetail()
    },
    handleVoidQuote(){
      this.$refs['void-quote-dialog'].changeDialog()
    },
    handlerVoidPolicy() {
      if(this.productId==93)
      {
        this.handleVoidQuote()
        return
      }
      this.$refs['send-email-sms'].changeDialog()
    },
    handlerMarkIssuing(){
      this.$ConfirmBox({
        isNewConfirm:true,
        width:500,
        title:'Mark As Issuing',
        confirmBtn:'Continue',
        isGreen:true,
        message: 'This policy will no longer be adjustable. Continue?'
      }).then(() => {
        this.$refs['send-email-sms-issuing'].changeDialog()
      })
    },
    handlerMarkIssued(){
      this.$refs['mark-as-issued'].changeDialog()
    },
    // 開啓 adjust 流程
    handlerAdjustPolicy(data) {
      this.formData = data // 選中 policy 數據
      this.is_adjust = true
      this.showMain = false
      this.showAdjustPolicy = true
    },
    handlerEndorsePolicy(data) {
      this.formData = data // 選中 policy 數據
      this.is_adjust = false
      this.showMain = false
      this.showAdjustPolicy = true
    },
    handlerAdjustCancel() {
      this.showMain = true
      this.showAdjustPolicy = false
    },
    handlerAdjustDone(data) {
      const { order_id, stts, pcy_id } = data||{}
      this.handler().initUpdatePolicyDetail()
    },
    handlerVoidDone(data) {
      // const { order_id, pcy_id } = data
      this.mobileVoidParams = data
      if(this.hasVoidSmsContent){
        this.$refs['send-email-sms'].changeDialog()
      }else this.network().voidPolicyOrder()
      // this.handler().initUpdatePolicyDetail()
      // this.$router.replace({
      //   path: '/records/policy/detail',
      //   query: {
      //     id: order_id,
      //     pcy_id,
      //     product_id: this.productId
      //   }
      // })
    },
    event() {
      return {
        onComplete: type => {
          if(type === 0) {
            this.network().issueOrderCvr()
          }
          else if(type === 1) {
            this.network().orderTurnToNewPcy()
          }
          else {
            this.network().completeNewBusinessOrder()
          }
        }
      }
    },
    handler() {
      return {

        initUpdatePolicyDetail: () => {
          this.showMain = true
          this.showAdjustPolicy = false
          this.getProductDetail({
            hideLoading: true
          })
        },
        updatePolicyDetail: () => {
          this.getProductDetail({
            hideLoading: true
          })
        },
      }
    },

    getProductDetail(){
      let params = {
        order_id: this.orderId
      }
      switch(Number(this.productId)){
        case 90:
          this.network().getMicropolicyDetail(params)
          break
        case 91:
          this.network().getEwalletDetail(params)
          break
        case 92:
          this.network().getSportDetail(params)
          break
        case 93:
          this.network().getMobileDetail(params)
          break
        case 94:
          this.network().getInfectiousDetail(params)
          break
        case 95:
          this.network().getOverseaPaDetail(params)
          break
      }
    },
    network() {
      return {
        voidPolicyOrder: async (params) => {
          const { data } = await voidPolicyOrder({
            order_id: this.orderId,
            ...this.mobileVoidParams,
            ...params
          })
          this.handler().initUpdatePolicyDetail()
        },
        setTicketCs: async params => {
          const {data} = await orderCsSet({
            order_id: this.orderId,
            ...params
          })
          this.$message({
            type: 'success',
            message: 'Success'
          })
        },
        getMicropolicyDetail: async (params= {}) => {
          const {data} = await getMicropolicyDetail({
            ...params
          })
          this.detailData = data
        },
        covidVoidPolicy: async (params={})=> {
          const {data} = await covidVoidPolicy({
            ...params
          })
          const { code, message_language, message } = data
          if (!code) {
            this.$message({
              type: 'error',
              message: 'ERROR!',
            })
          } else {
            this.$message({
              type: 'success',
              message: message_language ? message_language : message,
            })
            this.$emit('success', data)
            this.getProductDetail()
          }
        },
        addPolicyRemark: async () => {
          const { data } = await addPolicyRemark({
            pcy_id: this.detailData.pcy_id,
            message: this.message
          })
          this.message = ''
          // todo 追加 remark
          this.remarkList.unshift(data)
        },
        orderTurnToNewPcy: async () => {
          const { data } = await orderTurnToNewPcy({
            order_id: this.orderId
          })
          this.handler().initUpdatePolicyDetail()
        },
        issueOrderCvr: async () => {
          const { data } = await issueOrderCvr({
            order_id: this.orderId
          })
          this.handler().initUpdatePolicyDetail()
        },
        completeNewBusinessOrder: async () => {
          const { data } = await completeNewBusinessOrder({
            order_id: this.orderId
          })
          this.handler().initUpdatePolicyDetail()
        },
        getAccountDetail: async ({customer_id}) => {
          const {data} = await getAccountDetail({
            customer_id
          })
          let {customer_profile} = data
          this.customer_profile = customer_profile
        },
        getPolicyDetailLog: async () => {
          const {data} = await getPolicyDetailLog({
            pcy_id:this.pcyId,
            page: this.pageConfig.currentPage,
          })
          this.logsData = data.data
        },

        getEwalletDetail: async (params= {}) => {
          const {data} = await getEwalletDetail({
            ...params
          })
          this.detailData = data
        },
        getSportDetail: async (params) => {
          const {data} = await getSportDetail(params)
          this.detailData = data
        },
        getMobileDetail: async (params) => {
          const {data} = await getMobileDetail(params)
          this.detailData = data
        },
        getInfectiousDetail: async (params) => {
          const {data} = await getInfectiousDetail(params)
          this.detailData = data
        },
        getOverseaPaDetail: async (params) => {
          const {data} = await getOverseaPaDetail(params)
          this.detailData = data
        },
        orderIssueIssuing: async (params) => {
          const {data} = await orderIssueIssuing({
            order_id:this.orderId,
            ...this.issuingForm
          })
          this.handler().initUpdatePolicyDetail()
        },
      }
    }
  }
}
</script>
<style lang="scss">
.detail-page-container {
  .el-loading-mask {
    .el-loading-spinner {
      top: 200px;
    }
  }
}
</style>
<style lang="scss" scoped>
.detail-page-container {
  position: relative;
  .flex-wrap{
    flex-wrap: wrap;
  }
  .top-bar {
    padding-top: 5px;
    color: #409eff;
    font-size: 13px;
    font-weight: bold;
    border-top: 2px solid #409eff;
  }
  .main-container {
    margin-top: 20px;
    .main-header {
      padding-bottom: 10px;
      &.has-border{
        box-shadow: inset 0px -1px 0px #D1D5DA;
      }
      .header-title {
        display: flex;
        padding-bottom: 15px;
        align-items: center;
        .icon {
          font-size: 18px;
          &.gray {
            color: #586069;
          }
          &.green {
            color: #22863A;
          }
          &.red {
            color: #D73A49;
          }
        }
        h3 {
          padding-bottom: 0;
          padding: 0 15px;
          color: #24292E;
        }
        .hcid {
          display: inline-block;
          padding-right: 20px;
          font-size: 16px;
          color: #586069;
          font-weight: 500;
        }
      }
      .span-status, .span-options {
        display: inline-block;
        margin-right: 15px;
        padding: 5px 10px;
        border-radius: 12px;
        font-size: 12px;
        line-height: 14px;
        color: white;
        font-weight: 500;
        .svg-inline--fa {
          margin-right: 5px;
          font-size: 14px;
        }
      }
      .span-status {
        &.green {
          background: #28a745;
          color: white;
        }
        &.orange {
          background: #E36209;
          color: white;
        }
        &.yellow-dark {
          background: #DBAB09;
        }
        &.blue {
          background: #0366D6;
        }
        &.red {
          background: #d73a49;
        }
        &.min-green {
          background: #dcffe4;
          color: #28a745;
        }
      }
      .span-options{
        border: 1px solid;
        &.gray {
          border-color: #586069;
          color: #586069;
        }
        &.green {
          border-color: #22863A;
          color: #22863A;
        }
        &.red {
          border-color: #D73A49;
          color: #D73A49;
        }
        &.gold {
          border-color: #735C0F;
          color: #735C0F;
        }
        &.blue {
          border-color: #0366D6;
          color: #0366D6;
        }
        &.orange {
          border-color: #C24E00;
          color: #C24E00;
        }
        &.black {
          border-color: #24292E;
          color: #24292E;
        }
      }
      .header-date {
        padding-right: 15px;
        font-size: 14px;
        color: #586069;
        font-weight: 500;
      }
      .header-ref{
        font-size: 12px;
        line-height: 18px;
        color: #586069;
        font-weight: 600;
        .number-color{
          font-weight: 400;
        }
      }
      .header-label {
        display: inline-block;
        padding-right: 15px;
        color: #586069;
        font-size: 14px;
        font-weight: 500;
      }
      .top {
        display: flex;
        align-items: center;
        padding-bottom: 15px;
        h1 {
          padding-bottom: 0;
        }
        .company-logo {
          margin-right: 15px;
          height: 42px;
          img {
            height: 42px;
          }
        }
      }
      .info-container {
        display: flex;
        justify-content: space-between;
        margin: 0 -15px;
        padding: 15px 15px 0 15px;
        border-top: 1px solid #dddfe7;
        & > div {
          font-size: 14px;
          color: #91939a;
          & > span:first-child {
            display: block;
            padding-bottom: 5px;
            font-size: 14px;
            font-weight: bold;
            color: #616266;
          }
        }
      }
    }
    .main-body {
      display: flex;
      .main-content {
        flex: 1;
        margin-right: 15px;
        .status-bar {
          margin-bottom: 15px;
          padding: 15px;
          align-items: center;
          border-radius: 4px;
        }
        .status-bar-endorsement {
          background: #e6a23d;
          .left {
            color: white;
            span {
              display: block;
              font-size: 14px;
              &:first-child {
                font-size: 16px;
                font-weight: bold;
              }
            }
          }
        }
        .status-bar-blue {
          background: #e1efff;
          .left {
            color: #1d43a0;
            font-size: 14px;
            span:first-child {
              display: inline-block;
              padding-right: 15px;
              font-weight: bold;
            }
          }
        }
        .void-status {
          padding: 15px;
          background: #c81f1d;
          color: white;
          font-size: 14px;
          border-radius: 4px;
          span:first-child {
            display: inline-block;
            padding-right: 15px;
            font-weight: 500;
          }
        }
      }
      aside {
        width: 250px;
        .yellow-card {
          background: #FBCB15;
          .label {
            color: #723C14;
          }
          p {
            padding-bottom: 8px;
            color: #723C14;
            font-size: 14px;
          }
        }
        .remark-add {
          z-index: 2;
          margin: 0 -15px;
          padding: 15px 15px 0 15px;
          border-top: 1px solid #dddfe7;
        }
        .remarks-container {
          z-index: 1;
          max-height: 300px;
          overflow-y: auto;
          .remark-box {
            margin-bottom: 10px;
            font-size: 12px;
            color: #91939a;
            .remark-header {
              display: flex;
              justify-content: space-between;
              span:first-child {
                font-weight: bold;
              }
            }
            p {
              padding-bottom: 10px;
              color: #616266;
            }
          }
        }
        .plan-card {
          .flex {
            .logo {
              width: 80px;
              height: 45px;
              img {
                max-width: 80px;
                max-height: 45px;
              }
            }
            p {
              padding-left: 10px;
              font-size: 14px;
              line-height: 18px;
              font-weight: 500;
              color: #616266;
            }
          }
        }
        .g-btn{
          background: rgba(46, 164, 79, 1);
          color: rgb(255,255,255);
        }
      }
    }
  }
  .number-color{
    color:#24292E ;
    //font-weight: 480;
  }
  .number-fontsize{
    font-size: 14px;
    font-weight: normal;
  }
  .purple {
    background: #6F42C1;
  }
  .small{
    font-weight: normal!important;
  }
  .unname{
    font-style: italic;
  }
  .name{
    color: #616266;
  }
  .button-width{
    .el-button{
      width: 100%;
      font-size: 14px;
    }
  }
  .unbuyable-status{
    background-color: #FFFBDD!important;
    margin-bottom: 20px;
  }
  .border-b {
    //margin: 10px -15px 0 -15px;
    padding: 15px ;
    border: 1px solid rgba(176, 136, 0, 0.2);
    border-radius: 15px;
    .title {
      margin-bottom: 5px;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      display: flex;
      align-items: center;
      color: #24292E;
    }
  }
}
span.edit{
  color: #0366D6;
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;
}
.description-content{
  font-weight: 400;
  font-size: 14px;
  color: #24292E;
  margin-bottom: 15px;
}
</style>
